import React from 'react';


export const useAnimatedState = <T extends string>(defaultState: T) => {
  type flow = 'back' | 'next';
  const [ state, setState ] = React.useState<T>(defaultState);
  const [ animation, setAnimation ] = React.useState<{
    flow: flow;
    animateIn: boolean;
  }>({
    flow: 'next',
    animateIn: true
  });

  const handleExitedRef = React.useRef<() => void>();
  const handleExited = () => {
    handleExitedRef.current?.();
    setAnimation({ ...animation, animateIn: true });
  };
  const goTo = (_direction: flow, _state: (T | (() => void))) => {
    setAnimation({
      ...animation,
      flow: _direction,
      animateIn: false,
    });
    if (typeof _state === 'function') {
      handleExitedRef.current = _state;
    } else {
      handleExitedRef.current = () => {
        setState(_state);
      };
    }
  };

  return {
    goTo,
    state,
    handleExited,
    ...animation,
  };
};
